import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxSpinnerModule } from "ngx-spinner";
import { CoreModule } from "../core/core.module";
import { OnlyNumbersDirective } from './directivas/only-numbers.directive';
import { OnlyLettersDirective } from './directivas/only-letters.directive';
import { DocumentDirective } from './directivas/document.directive';
import { InformacionContactoComponent } from './components/informacion-contacto/informacion-contacto.component';
import { LineasAtencionComponent } from './components/lineas-atencion/lineas-atencion.component';
import { ContactoAtencionInfoComponent } from './components/contacto-atencion-info/contacto-atencion-info.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ModalService } from "./service/modal.service";
import { BloquearPegadoNegativoDirective } from './directivas/bloquear-pegado-negativo.directive';
import { NextFieldIdDirective } from './directivas/next-field-id.directive';
import { NgSelectOpenDirective } from './directivas/ng-select-open.directive';
import { NumeroDocumentoPorTipoDirective } from './directivas/numero-documento-por-tipo.directive';
import { ClarityConsentModalComponent } from './components/clarity-consent-modal/clarity-consent-modal.component';
import { PesosCopPipe } from './pipes/pesos-cop.pipe';


@NgModule({
    declarations: [
        OnlyNumbersDirective,
        OnlyLettersDirective,
        DocumentDirective,
        NumeroDocumentoPorTipoDirective,
        InformacionContactoComponent,
        LineasAtencionComponent,
        PaginationComponent,
        BloquearPegadoNegativoDirective,
        NextFieldIdDirective,
        NgSelectOpenDirective,
        ClarityConsentModalComponent,
        PesosCopPipe,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        NgxSpinnerModule,
        ContactoAtencionInfoComponent,
    ],
    exports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        NgxSpinnerModule,
        OnlyNumbersDirective,
        OnlyLettersDirective,
        DocumentDirective,
        NumeroDocumentoPorTipoDirective,
        InformacionContactoComponent,
        LineasAtencionComponent,
        ContactoAtencionInfoComponent,
        PaginationComponent,
        BloquearPegadoNegativoDirective,
        NextFieldIdDirective,
        NgSelectOpenDirective,
        ClarityConsentModalComponent,
        PesosCopPipe,
    ],
  providers: [
    ModalService
  ]
})
export class SharedModule {}
